webpackJsonp([5],{

/***/ 1366:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1521)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(1473),
  /* template */
  __webpack_require__(1593),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e0d39240",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1404:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormValidator = __webpack_require__(90);

var _FormValidator2 = _interopRequireDefault(_FormValidator);

var _XmModal = __webpack_require__(345);

var _XmModal2 = _interopRequireDefault(_XmModal);

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

var _PasswordForm = __webpack_require__(757);

var _PasswordForm2 = _interopRequireDefault(_PasswordForm);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      modalName: 'change-password',
      passwordDetails: null,
      passwordDetailsValid: false,
      formValid: false,
      changingPassword: false,
      passwordSuccessMessage: 'Your password has been successfully changed. You will need to re-login.'
    };
  },


  computed: {
    changePasswordDisabled: function changePasswordDisabled() {
      return !this.passwordDetailsValid;
    }
  },

  methods: {
    setPasswordDetails: function setPasswordDetails(details) {
      this.passwordDetails = details;
    },
    setPasswordDetailsValid: function setPasswordDetailsValid(valid) {
      this.passwordDetailsValid = valid;
    },
    changePassword: function changePassword() {
      this.changingPassword = true;
      var self = this;
      return this.$store.dispatch('changePassword', {
        currentPass: this.passwordDetails.old_password,
        newPass: this.passwordDetails.password
      }).then(function () {
        self.$store.commit(types.ADD_NOTIFICATION, { type: 'success', message: self.passwordSuccessMessage });
        self.$store.dispatch('logout', self.$router);
        self.changingPassword = false;
      }).catch(function (error) {
        self.changingPassword = false;
        return reject(error);
      });
    }
  },
  components: {
    PasswordForm: _PasswordForm2.default,
    FormValidator: _FormValidator2.default,
    XmModal: _XmModal2.default
  }
};

/***/ }),

/***/ 1417:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(1404),
  /* template */
  __webpack_require__(1435),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1435:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('xm-modal', {
    attrs: {
      "title": "Update Password",
      "size": "lg",
      "save-text": "Change password",
      "save": _vm.changePassword,
      "save-disabled": _vm.changePasswordDisabled,
      "id": "change-password-modal"
    }
  }, [_c('div', [_c('password-form', {
    attrs: {
      "require-old-password": true,
      "password-in-modal": true
    },
    on: {
      "input": _vm.setPasswordDetails,
      "form-state": _vm.setPasswordDetailsValid
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1443:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

var _bootstrapVue = __webpack_require__(31);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  name: 'LogoutNotification',
  methods: {
    closeLogoutNotification: function closeLogoutNotification() {
      this.$store.commit(types.HIDE_LOGOUT_NOTIFICATION);
    }
  },
  components: {
    BIconLockFill: _bootstrapVue.BIconLockFill
  }
};

/***/ }),

/***/ 1473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(35);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(42);

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

var _LogoutNotification = __webpack_require__(1528);

var _LogoutNotification2 = _interopRequireDefault(_LogoutNotification);

var _ChangePasswordModal = __webpack_require__(1417);

var _ChangePasswordModal2 = _interopRequireDefault(_ChangePasswordModal);

var _bootstrapVue = __webpack_require__(31);

var _vue = __webpack_require__(111);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_bootstrapVue.ModalPlugin);

exports.default = {
  components: {
    LogoutNotification: _LogoutNotification2.default,
    ChangePasswordModal: _ChangePasswordModal2.default,
    BIconEyeFill: _bootstrapVue.BIconEyeFill,
    BIconEyeSlashFill: _bootstrapVue.BIconEyeSlashFill,
    BButton: _bootstrapVue.BButton
  },
  data: function data() {
    return {
      username: '',
      password: '',

      hasError: false,
      passwordFieldType: 'password'
    };
  },
  mounted: function mounted() {
    this.checkLoggedIn();
    this.checkTimeout();
    this.checkPassword();
  },


  computed: (0, _extends3.default)({
    lowercaseUsername: function lowercaseUsername() {
      return this.username.toLowerCase();
    },
    timeout: function timeout() {
      if (this.$route.query !== undefined && this.$route.query.timeout !== undefined) {
        return true;
      } else {
        return false;
      }
    },
    redirect: function redirect() {
      if (this.$route.query !== undefined && this.$route.query.redirect !== undefined) {
        return this.$route.query.redirect;
      } else {
        return 'account';
      }
    },
    passwordRedirect: function passwordRedirect() {
      return this.$route.query !== undefined && this.$route.query.password !== undefined;
    }
  }, (0, _vuex.mapState)({
    loggedIn: function loggedIn(state) {
      return state.user.loggedIn;
    },
    showLogoutNotification: function showLogoutNotification(state) {
      return state.notifications.showLogoutNotification;
    }
  })),

  methods: {
    switchVisibility: function switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
    },
    checkLoggedIn: function checkLoggedIn() {
      var _this = this;

      if (this.$store.state.user.loggedIn === undefined) {
        this.$store.dispatch('getProfile').then(function (response) {
          if (_this.$store.state.user.loggedIn) {
            _this.$router.push({ name: 'account' });
          }
        });
      } else if (this.$store.state.user.loggedIn) {
        this.$router.push({ name: 'account' });
      }
    },
    checkTimeout: function checkTimeout() {
      if (this.$route.query !== undefined && this.$route.query.timeout !== undefined) {
        this.$store.commit(types.ADD_NOTIFICATION, {
          type: 'warning',
          message: 'Your session has timed out and you need to relogin'
        });
      }
    },
    checkPassword: function checkPassword() {
      if (!this.$store.state.user.loggedIn && this.passwordRedirect) {
        this.$store.commit(types.ADD_NOTIFICATION, {
          type: 'info',
          message: 'Please login to change your password'
        });
      }
    },
    login: function login() {
      var _this2 = this;

      if (this.username.includes('@')) {
        this.$store.commit(types.ADD_NOTIFICATION, { 'type': 'warning', 'message': 'Username cannot be an email address. If you don\'t know yours please click "Recover Username"' });
        this.username = this.username.split('@')[0];
        return;
      }
      this.$store.dispatch('login', {
        username: this.lowercaseUsername,
        password: this.password
      }).then(function () {
        _this2.clearForm();
        if (_this2.passwordRedirect) {
          _this2.$bvModal.show('change-password-modal');
        }
        _this2.$router.push({ name: _this2.redirect });
      }, function (errorMessage) {
        _this2.clearForm();
        _this2.$store.commit(types.ADD_NOTIFICATION, {
          type: 'error',
          message: errorMessage
        });
      });
    },
    clearForm: function clearForm() {
      this.username = '';
      this.password = '';
    }
  }
};

/***/ }),

/***/ 1494:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1360)(true);
// imports


// module
exports.push([module.i, "@media (max-width:768px){.mobile-top-pad[data-v-6b9bda70]{padding-top:1em}}h4.underlined[data-v-6b9bda70]{border-bottom:1px solid #ccc;padding-bottom:.5em}div.vam[data-v-6b9bda70],table.vam td[data-v-6b9bda70],tr.vam td[data-v-6b9bda70]{vertical-align:middle!important}.red[data-v-6b9bda70]{color:red}.bottom-margin[data-v-6b9bda70]{margin-bottom:1.75em}.uppercase[data-v-6b9bda70]{text-transform:uppercase}.nolines td[data-v-6b9bda70]{border:0!important}.faded[data-v-6b9bda70]{opacity:.5}.row.faded label[data-v-6b9bda70]{font-weight:400!important}.largetext[data-v-6b9bda70]{font-size:120%}.equal-height-children[data-v-6b9bda70]{display:flex;align-items:center;flex-wrap:wrap}.no-fx-form-control[data-v-6b9bda70]{border:0;box-shadow:none;padding-right:0;padding-left:0;background:transparent}.text-align-right[data-v-6b9bda70]{text-align:right}.width-auto-inline[data-v-6b9bda70]{width:auto!important;display:inline-block}.h4-size-text[data-v-6b9bda70]{font-size:18px}.borderless[data-v-6b9bda70]{border:0!important}", "", {"version":3,"sources":["/home/gitlab-runner/builds/Je1HEHoK/0/xmission/manage-frontend/src/components/LogoutNotification.vue"],"names":[],"mappings":"AACA,yBACA,iCAAkC,eAAe,CAChD,CACA,AACD,+BACE,6BAA6B,AAC7B,mBAAoB,CACrB,AAID,kFACE,+BAAiC,CAClC,AACD,sBAAuB,SAAS,CAC/B,AACD,gCAAiC,oBAAoB,CACpD,AACD,4BACE,wBAAwB,CACzB,AACD,6BACE,kBAAoB,CACrB,AACD,wBAAyB,UAAW,CACnC,AACD,kCAAmC,yBAA6B,CAC/D,AACD,4BAA6B,cAAc,CAC1C,AACD,wCAAyC,aAAa,AAAC,mBAAoB,AAAC,cAAgB,CAC3F,AACD,qCAAsC,SAAS,AAAC,gBAAgB,AAAC,gBAAgB,AAAC,eAAe,AAAC,sBAAsB,CACvH,AACD,mCAAoC,gBAAiB,CACpD,AACD,oCAAqC,qBAAsB,AAAC,oBAAqB,CAChF,AACD,+BAAgC,cAAc,CAC7C,AACD,6BAA8B,kBAAmB,CAChD","file":"LogoutNotification.vue","sourcesContent":["\n@media (max-width: 768px) {\n.mobile-top-pad[data-v-6b9bda70] {padding-top:1em\n}\n}\nh4.underlined[data-v-6b9bda70] {\n  border-bottom:1px solid #ccc;\n  padding-bottom:0.5em\n}\n\n\n/**redundant**/\ntr.vam td[data-v-6b9bda70], table.vam td[data-v-6b9bda70], div.vam[data-v-6b9bda70] {\n  vertical-align:middle !important;\n}\n.red[data-v-6b9bda70] {color:red\n}\n.bottom-margin[data-v-6b9bda70] {margin-bottom:1.75em\n}\n.uppercase[data-v-6b9bda70] {\n  text-transform:uppercase\n}\n.nolines td[data-v-6b9bda70] {\n  border:0 !important;\n}\n.faded[data-v-6b9bda70] {opacity:0.5\n}\n.row.faded label[data-v-6b9bda70] {font-weight:normal !important\n}\n.largetext[data-v-6b9bda70] {font-size:120%\n}\n.equal-height-children[data-v-6b9bda70] {display:flex; align-items: center; flex-wrap: wrap;\n}\n.no-fx-form-control[data-v-6b9bda70] {border:0; box-shadow:none; padding-right:0; padding-left:0; background:transparent\n}\n.text-align-right[data-v-6b9bda70] {text-align:right;\n}\n.width-auto-inline[data-v-6b9bda70] {width:auto !important; display:inline-block;\n}\n.h4-size-text[data-v-6b9bda70] {font-size:18px\n}\n.borderless[data-v-6b9bda70] {border:0 !important\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1501:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1360)(true);
// imports


// module
exports.push([module.i, "#login-card[data-v-e0d39240]{background-color:#fff;border:1px solid rgba(0,0,0,.125);color:#212529}.liteMode #login-card[data-v-e0d39240]{box-shadow:0 0 255px #bbb}#login-card .card-body[data-v-e0d39240]{background-color:#fff;color:#212529}#login-card input[type=password][data-v-e0d39240],#login-card input[type=text][data-v-e0d39240]{border:1px solid #bbb;background-color:#f5f5f5;padding:8px 12px;font-size:110%;color:#000}#login-card input[type=password][data-v-e0d39240]:focus,#login-card input[type=text][data-v-e0d39240]:focus{background-color:#fff!important}#login-card input[data-v-e0d39240]::placeholder{font-size:14px;color:#aaa}#login-card label[data-v-e0d39240]{margin-bottom:.3rem}#login-card .btn-light[data-v-e0d39240]{color:#212529!important;background:#e2e6ea!important;border:1px solid #ccc!important}#login-card .btn-light[data-v-e0d39240]:hover{background:#cbcfd3!important;border-color:#aaa!important}#login-card .btn-primary[data-v-e0d39240]{background-color:#0290ae!important;color:#fff!important;border-color:#0290ae!important}#login-card .btn-primary[data-v-e0d39240]:hover{background-color:#027a94!important;border-color:#027a94!important}@media (max-width:950px){#xmcp-title span[data-v-e0d39240]{display:block;font-size:50%}}", "", {"version":3,"sources":["/home/gitlab-runner/builds/Je1HEHoK/0/xmission/manage-frontend/src/pages/Login.vue"],"names":[],"mappings":"AACA,6BACE,sBAAuB,AACvB,kCAAmC,AACnC,aAAe,CAChB,AACD,uCACE,yBAA0B,CAC3B,AACD,wCACE,sBAAuB,AACvB,aAAe,CAChB,AACD,gGACE,sBAAuB,AACvB,yBAAyB,AACzB,iBAAiB,AACjB,eAAe,AACf,UAAY,CACb,AACD,4GACE,+BAAkC,CACnC,AACD,gDACE,eAAe,AACf,UAAU,CACX,AACD,mCACE,mBAAsB,CACvB,AACD,wCACE,wBAA0B,AAC1B,6BAA8B,AAC9B,+BAAiC,CAClC,AACD,8CACE,6BAA8B,AAC9B,2BAA6B,CAC9B,AACD,0CACE,mCAAoC,AACpC,qBAAuB,AACvB,8BAAiC,CAClC,AACD,gDACE,mCAAoC,AACpC,8BAAgC,CACjC,AAGD,yBACA,kCACI,cAAc,AACd,aAAc,CACjB,CACA","file":"Login.vue","sourcesContent":["\n#login-card[data-v-e0d39240] {\n  background-color: #fff;\n  border: 1px solid rgba(0,0,0,.125);\n  color: #212529;\n}\n.liteMode #login-card[data-v-e0d39240] {\n  box-shadow:0 0 255px #bbb;\n}\n#login-card .card-body[data-v-e0d39240] {\n  background-color: #fff;\n  color: #212529;\n}\n#login-card input[type=text][data-v-e0d39240], #login-card input[type=password][data-v-e0d39240] {\n  border: 1px solid #bbb;\n  background-color:#f5f5f5;\n  padding:8px 12px;\n  font-size:110%;\n  color:black;\n}\n#login-card input[type=text][data-v-e0d39240]:focus, #login-card input[type=password][data-v-e0d39240]:focus {\n  background-color:white !important;\n}\n#login-card input[data-v-e0d39240]::placeholder {\n  font-size:14px;\n  color:#aaa\n}\n#login-card label[data-v-e0d39240] {\n  margin-bottom: 0.3rem;\n}\n#login-card .btn-light[data-v-e0d39240] {\n  color: #212529 !important;\n  background:#E2E6EA !important;\n  border:1px solid #ccc !important;\n}\n#login-card .btn-light[data-v-e0d39240]:hover {\n  background:#cbcfd3 !important;\n  border-color:#aaa !important;\n}\n#login-card .btn-primary[data-v-e0d39240] {\n  background-color:#0290AE !important;\n  color:white !important;\n  border-color: #0290AE !important;\n}\n#login-card .btn-primary[data-v-e0d39240]:hover {\n  background-color:#027a94 !important;\n  border-color:#027a94 !important;\n}\n\n/** responsive **/\n@media (max-width: 950px) {\n#xmcp-title span[data-v-e0d39240] {\n    display:block;\n    font-size:50%;\n}\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1514:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1494);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1361)("364987ef", content, true, {});

/***/ }),

/***/ 1521:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1501);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1361)("7325843d", content, true, {});

/***/ }),

/***/ 1528:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1514)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(1443),
  /* template */
  __webpack_require__(1577),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6b9bda70",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1577:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "alert alert-info",
    staticStyle: {
      "max-width": "640px",
      "margin": "0 auto"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closeLogoutNotification()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticStyle: {
      "border-top": "1px solid #87B0C4",
      "padding-top": "1em",
      "opacity": "0.7",
      "font-size": "90%"
    }
  }, [_c('b-icon-lock-fill', {
    staticStyle: {
      "float": "left",
      "font-size": "32px",
      "width": "46px",
      "opacity": "0.5",
      "margin": "2px 0 40px 0"
    }
  }, [_vm._v(" ")]), _vm._v("\n            Security Notice:\n            XMission will "), _c('b', [_vm._v("never")]), _vm._v(" contact you to ask for your password, account or other personal information. If you receive any request of this nature, please contact us immediately at 801-539-0852 or "), _c('a', {
    attrs: {
      "href": "mailto:support@xmission.com"
    }
  }, [_vm._v("support@xmission.com")]), _vm._v(".\n      ")], 1)]), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('span', [_vm._v("\n            Logout complete\n          ")])])
}]}

/***/ }),

/***/ 1593:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showLogoutNotification) ? _c('logout-notification') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 offset-lg-3 col-md-8 offset-md-2 card",
    attrs: {
      "id": "login-card"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Username")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control mb-4",
    attrs: {
      "type": "text",
      "name": "username",
      "autofill": "username",
      "autocomplete": "on"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group mb-5"
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), (_vm.passwordFieldType === 'password') ? _c('b-icon-eye-slash-fill', {
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.switchVisibility
    }
  }) : _vm._e(), _vm._v(" "), (_vm.passwordFieldType === 'text') ? _c('b-icon-eye-fill', {
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.switchVisibility
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.passwordFieldType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "autofill": "password",
      "type": "password",
      "autocomplete": "on",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password) ? _vm._i(_vm.password, null) > -1 : (_vm.password)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.password = $$c
        }
      }
    }
  }) : ((_vm.passwordFieldType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "autofill": "password",
      "type": "password",
      "autocomplete": "on",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password, null)
    },
    on: {
      "change": function($event) {
        _vm.password = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "autofill": "password",
      "type": "password",
      "autocomplete": "on",
      "type": _vm.passwordFieldType
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-sm btn-light mt-2",
    attrs: {
      "to": "username-recovery"
    }
  }, [_vm._v("Login Help")]), _c('span', [_vm._v(" ")])], 1)]), _vm._v(" "), _c('change-password-modal')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "mb-4",
    attrs: {
      "id": "xmcp-title"
    }
  }, [_c('span', [_vm._v("XMission")]), _vm._v(" Control Panel")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn float-right btn-primary btn-lg",
    attrs: {
      "type": "submit"
    }
  }, [_c('b', [_vm._v("Log In")])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/5.ec54d5643167ba8807dc.js